const _ = require('lodash');

module.exports = function(Highcharts) {
  return {
    setDefaults: function() {
      Highcharts = Highcharts || {
        setOptions: function() {}
      };
      Highcharts.setOptions({
        chart: {
          style: {
            fontFamily: 'Poppins'
          }
        },
        time: {
          useUTC: false
        },
        plotOptions: {
          series: {
            cropThreshold: 8000,
            turboThreshold: 8000
          }
        }
      });
    },
    splitTooltipOverride: function() {
      Highcharts = Highcharts || {
        Tooltip: {
          prototype: {}
        }
      };
      Highcharts.Tooltip.prototype.renderSplit = function(labels, points) {
        var tooltip = this,
          boxes = [],
          chart = this.chart,
          ren = chart.renderer,
          options = this.options,
          headerHeight,
          tooltipLabel = this.getLabel(),
          H = Highcharts,
          each = H.each,
          pick = H.pick,
          headerTop,
          distributionBoxTop = chart.plotTop;

        // Graceful degradation for legacy formatters
        if (H.isString(labels)) {
          labels = [false, labels];
        }
        // Create the individual labels for header and points, ignore footer
        each(labels.slice(0, points.length + 1), function(str, i) {
          if (str !== false) {
            var point = points[i - 1] || {
                // use the crosshair label // Item 0 is the header. Instead of this, we could also
                isHeader: true,
                plotX: points[0].plotX
              },
              owner = point.series || tooltip,
              tt = owner.tt,
              series = point.series || {},
              colorClass = 'highcharts-color-' + pick(point.colorIndex, series.colorIndex, 'none'),
              target,
              x,
              bBox,
              boxWidth;

            // Store the tooltip referance on the series
            if (!tt) {
              owner.tt = tt = ren
                .label(null, null, null, 'rect', null, null, options.useHTML)
                .addClass('highcharts-tooltip-box ' + colorClass)
                .attr({
                  padding: options.padding,
                  r: options.borderRadius,
                  /*= if (build.classic) { =*/
                  fill: options.backgroundColor,
                  stroke: options.borderColor || point.color || series.color || '${palette.neutralColor80}',
                  'stroke-width': options.borderWidth,
                  zIndex: options.zIndex || 10
                  /*= } =*/
                })
                .add(tooltipLabel);
            }

            tt.isActive = true;
            tt.attr({
              text: str
            });
            /*= if (build.classic) { =*/
            tt.css(options.style).shadow(options.shadow);
            /*= } =*/

            // Get X position now, so we can move all to the other side in
            // case of overflow
            bBox = tt.getBBox();
            boxWidth = bBox.width + tt.strokeWidth();
            if (point.isHeader) {
              headerHeight = bBox.height;
              if (chart.xAxis[0].opposite) {
                headerTop = true;
                distributionBoxTop -= headerHeight;
              }
              x = Math.max(
                0, // No left overflow
                Math.min(
                  point.plotX + chart.plotLeft - boxWidth / 2,
                  // No right overflow (#5794)
                  chart.chartWidth +
                    // Scrollable plot area
                    (chart.scrollablePixels ? chart.scrollablePixels - chart.marginRight : 0) -
                    boxWidth
                )
              );
            } else {
              x = point.plotX + chart.plotLeft - pick(options.distance, 16) - boxWidth;
            }

            let leftAligned = false;
            let moveCoefficient = boxWidth > 200 ? 2 : 1;
            if (x + boxWidth + chart.plotLeft * moveCoefficient >= chart.plotWidth - chart.plotLeft * moveCoefficient) {
              leftAligned = true;
            }

            // Prepare for distribution
            target = (point.series && point.series.yAxis && point.series.yAxis.pos) + (point.plotY || 0);
            target -= distributionBoxTop;

            if (point.isHeader) {
              target = headerTop ? -headerHeight : chart.plotHeight + headerHeight;
            }
            boxes.push({
              moveCoefficient: moveCoefficient,
              leftAligned: leftAligned,
              target: target,
              rank: point.isHeader ? 1 : 0,
              size: owner.tt.getBBox().height + 1,
              width: owner.tt.getBBox().width + 1,
              point: point,
              x: x,
              tt: tt
            });
          }
        });

        // Clean previous run (for missing points)
        this.cleanSplit();

        // Distribute and put in place
        H.distribute(boxes, chart.plotHeight + headerHeight);
        each(boxes, function(box) {
          var point = box.point,
            series = point.series;

          // Put the label in place
          box.tt.attr({
            x: (function() {
              if (point.isHeader || box.leftAligned) {
                if (!point.isHeader && box.leftAligned) {
                  if (chart.leftLblPos > 0) {
                    const pos = chart.leftLblPos - box.width - 16;
                    if (pos >= 0) {
                      return pos;
                    } else {
                      return box.x;
                    }
                  } else {
                    return box.x;
                  }
                }

                return box.x;
              }

              return point.plotX + chart.plotLeft + pick(options.distance, 16);
            })(),
            y: (function() {
              if (box.leftAligned && !point.isHeader) {
                return box.pos;
              }
              return box.pos + chart.plotTop;
            })(),
            anchorX: point.isHeader ? point.plotX + chart.plotLeft : point.plotX + series.xAxis.pos,
            anchorY: point.isHeader ? box.pos + chart.plotTop - 15 : point.plotY + series.yAxis.pos
          });
        });
      };
    },
    plotlinesTooltip: function(text) {
      return {
        mouseover: function(e) {
          const series = this.axis.series[0],
            chart = series.chart,
            PointClass = series.pointClass,
            tooltip = chart.tooltip,
            point = new PointClass().init(series, ['Plotline', this.options.value]),
            normalizedEvent = chart.pointer.normalize(e);

          point.tooltipPos = [normalizedEvent.chartX - chart.plotLeft, normalizedEvent.chartY - chart.plotTop];
          point.text = text;
          tooltip.refresh(point);
        },
        mouseout: function(e) {
          this.axis.chart.tooltip.hide();
        }
      };
    },
    getFontSizeConfig: function(chart, isWallmode) {
      const baseConfig = {
        xAxis: [
          {
            labels: {
              style: {
                fontSize: '1.2em'
              }
            },
            title: {
              style: {
                fontSize: '1.3em'
              }
            }
          },
          {
            opposite: true,
            labels: {
              style: {
                fontSize: '1.2em'
              }
            },
            title: {
              style: {
                fontSize: '1.3em'
              }
            }
          }
        ],
        yAxis: {
          title: {
            style: {
              fontSize: '1.3em'
            }
          },
          labels: {
            style: {
              fontSize: '1.2em'
            }
          }
        }
      };

      const baseMasterConfig = {
        yAxis: {
          title: {
            style: {
              fontSize: '1.3em'
            }
          },
          labels: {
            style: {
              fontSize: '1.2em'
            }
          }
        },
        xAxis: [
          {
            title: {
              style: {
                fontSize: '1.3em'
              }
            },
            labels: {
              style: {
                fontSize: '1.2em'
              }
            }
          },
          {
            opposite: true,
            title: {
              style: {
                fontSize: '1.3em'
              }
            },
            labels: {
              style: {
                fontSize: '1.2em'
              }
            }
          }
        ]
      };

      switch (chart) {
        case 'percentile': {
          return {
            fontSize: isWallmode ? '1.4em' : '12px'
          };
        }
        case 'cfd': {
          return {
            chart: {
              ...baseConfig
            },
            master: {
              xAxis: {
                labels: {
                  style: {
                    fontSize: '1.2em'
                  }
                }
              }
            }
          };
        }
        case 'cta': {
          return {
            chart: {
              ...baseConfig
            },
            master: { ...baseMasterConfig }
          };
        }
        case 'cth':
        case 'th':
        case 'fe': {
          const config = {
            labels: {
              style: {
                fontSize: '1.2em'
              }
            },
            title: {
              style: {
                fontSize: '1.3em'
              }
            }
          };

          return {
            chart: {
              xAxis: config,
              yAxis: config
            },
            master: { ...baseMasterConfig }
          };
        }
        case 'ctsp':
        case 'ctb':
        case 'mc':
        case 'mct':
        case 'trc':
        case 'ddp': {
          return {
            chart: {
              ...baseConfig
            },
            master: { ...baseMasterConfig }
          };
        }
      }
    },
    updateSeries: function(data, chart) {
      const diff = _.cloneDeep(data);
      // Remove old values
      _.forEach(diff.arr1, s => {
        const serieIndex = _.findIndex(chart.series, {
          color: s.color,
          name: s.name
        });
        if (!!chart.series[serieIndex]) {
          _.forEach(s.data, p => {
            const chartPoints = _.filter(chart.series[serieIndex].data, d => d.x === p.x && d.y === p.y);
            _.forEach(chartPoints, cp => {
              cp.remove(false);
            });
          });
          if (!chart.series[serieIndex].data.length) {
            chart.series[serieIndex].remove(false);
          }
        }
      });

      // Insert/update new values
      _.forEach(diff.arr2, s => {
        const serieIndex = _.findIndex(chart.series, {
          color: s.color,
          name: s.name
        });
        if (!chart.series[serieIndex]) {
          chart.addSeries(s, false);
        } else {
          _.forEach(s.data, p => {
            const predicate = !!p.card ? d => d.card.id === p.card.id : d => d && d.x === p.x && d.y === p.y;
            const pointIndex = _.findIndex(chart.series[serieIndex].data, predicate);
            if (pointIndex > -1) {
              chart.series[serieIndex].data[pointIndex].update(p, false);
            } else {
              chart.series[serieIndex].addPoint(p, false);
            }
          });
        }
      });
    }
  };
};
